import flatten from 'flat';
import resultScaleMapping from '@/data/resultScaleMapping.json';
import { logger } from '@/logger';
import { useAuthStore } from '@/stores/auth';

export function getRole() {
  return useAuthStore().role;
}

export function getResourceType() {
  return useAuthStore().resourceType;
}

export function getResource() {
  return useAuthStore().resourceId;
}

/**
 * Typetuin's own schools. Their students follow a course with an end date.
 * Students of every other school use a school license and get no end date.
 */
export const DEFAULT_SCHOOL_IDS = ['online', 'klassikaal', 'demo'];

export function isDefaultSchool(schoolId) {
  return DEFAULT_SCHOOL_IDS.includes(schoolId);
}

/** A student follows a course with an end date when all of their schools are Typetuin's own. */
export function followsCourseWithEndDate(schools) {
  return (
    schools.length > 0 && schools.every((school) => isDefaultSchool(school.id))
  );
}

export function handleGraphQLErrors(e) {
  logger.debug(e.graphQLErrors);
  return e.graphQLErrors
    .map((graphQLError) => {
      if (
        typeof graphQLError.extensions.exception.response.message === 'string'
      )
        return graphQLError.extensions.exception.response.message;
      return graphQLError.extensions.exception.response.message.join(', ');
    })
    .join(', ');
}

// flatten the data and remove graphql created keys with __typename
export function stripAndFlatten(data) {
  if (!data || !data.length) return null;
  const keysToDelete = Object.keys(flatten(data[0])).filter((key) =>
    key.includes('__typename'),
  );
  return data.map(flatten).map((item) => {
    keysToDelete.forEach((keyToDelete) => {
      // eslint-disable-next-line no-param-reassign
      delete item[keyToDelete];
    });

    // Object.keys(item).forEach((key) => {
    //   if (item[key] === null) {
    //     item[key] = '-';
    //   }
    // });

    return item;
  });
}

export const findAndReplaceObject = (input, needle, replacement) =>
  Object.fromEntries(
    Object.entries(input).map(([key, entry]) => {
      if (entry === needle) {
        return [key, replacement];
      }
      if (Object.prototype.toString.call(entry) === '[object Object]') {
        return [key, findAndReplaceObject(entry, needle, replacement)];
      }
      return [key, entry];
    }),
  );

export function defaultFiller(data, fillers) {
  return (
    data
      // The mapping over the data and creating new objects is needed to avoid mutating the original data
      // Errors for this include: `Uncaught TypeError: Cannot assign to read only property 'schoolDistrict' of object '#<Object>'`
      .map((item) => ({ ...item }))
      .map((item) => {
        Object.keys(item).forEach((key) => {
          if (item[key] === null && fillers[key]) {
            // eslint-disable-next-line no-param-reassign
            item[key] = fillers[key];
          }
        });
        return item;
      })
  );
}

export function calculateScaleMapping(value, type) {
  if (!resultScaleMapping[type] || value === null) return 'none';
  return (
    5 - resultScaleMapping[type].filter((result) => value >= result).length
  );
}

export function scaleMappingExists(type) {
  return resultScaleMapping[type];
}
